module.exports = __webpack_public_path__ + "static/media/man_01.cdf22788.png";